export const SET_MENU_ITEM_ACTIVE = 'SET_MENU_ITEM_ACTIVE';
